import React, {Component} from 'react'
import WelcomeForm from './welcome-form'
import Query from 'query-string'
import {actions} from 'react-redux-form'
import {Redirect} from 'react-router-dom'
import {welcomeAction} from '../../../actions/welcome'
import {connect} from 'react-redux'

class Welcome extends Component {

  constructor(props) {
    super(props);

    this.token = Query.parse(window.location.search).invitation_token || '';

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(payLoad) {
    const {dispatch} = this.props;
    dispatch(actions.submitFields('deep.admin_welcome', welcomeAction(payLoad, dispatch)))
  }

  render() {
    return (
      <div className="fluid">
        <WelcomeForm token={this.token} handleSubmit={this.handleSubmit}/>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    processed: state.welcome.processed,
  }
}

export default connect(mapStateToProps)(Welcome);


// WEBPACK FOOTER //
// ./src/components/admin/welcome/index.jsx